document.addEventListener("DOMContentLoaded", function () {
 
  const modeElements = Array.from(document.querySelectorAll("[data-role='mode']"));

  // === CANVAS / ROAD ANIMATION ===
  const canvas = document.getElementById("roadCanvas");
  const ctx = canvas.getContext("2d");
  const carImage = new Image();
  carImage.src = canvas?.dataset?.carImage || "";

  let speed = 200; // px/sn
  let offset = 0;
  let lastTimestamp = 0;
  const dashLength = 40;
  const gap = 30;

  function ensureCanvasSize() {
    const displayWidth = canvas.clientWidth;
    const displayHeight = canvas.clientHeight;
    if (canvas.width !== displayWidth || canvas.height !== displayHeight) {
      canvas.width = displayWidth;
      canvas.height = displayHeight;
    }
  }

  function drawDashedRoad() {
    ctx.fillStyle = "#2e2e2e";
    ctx.fillRect(0, 64, canvas.width, 64); // yol zemini
    ctx.strokeStyle = "#fff";
    ctx.lineWidth = 5;

    ctx.beginPath();
    let x = -offset;
    while (x < canvas.width) {
      ctx.moveTo(x, 96);
      ctx.lineTo(x + dashLength, 96);
      x += dashLength + gap;
    }
    ctx.stroke();
  }

  function animate(timestamp) {
    if (!lastTimestamp) lastTimestamp = timestamp;
    const deltaTime = (timestamp - lastTimestamp) / 1000;
    lastTimestamp = timestamp;

    offset += speed * deltaTime;
    const cycleLength = dashLength + gap;
    if (offset > cycleLength) offset -= cycleLength;

    ctx.clearRect(0, 0, canvas.width, canvas.height);
    ensureCanvasSize();
    drawDashedRoad();

    if (carImage.complete) {
      const maxCarWidth = 200;
      let carWidth = carImage.width;
      let carHeight = carImage.height;
      if (carWidth > maxCarWidth) {
        const scale = maxCarWidth / carWidth;
        carWidth = maxCarWidth;
        carHeight = carHeight * scale;
      }
      const x = (canvas.width - carWidth) / 2;
      const y = 32;
      ctx.drawImage(carImage, x, y, carWidth, carHeight);
    }

    requestAnimationFrame(animate);
  }
  if (canvas) carImage.onload = () => requestAnimationFrame(animate);

  // === HIZ TABLOSU ===
  const roadSpeeds = {
    eco:    { desktop: 175, mobile: 180 },
    city:   { desktop: 315, mobile: 324 },
    sport:  { desktop: 438, mobile: 450 },
    "sport+": { desktop: 525, mobile: 540 },
    stock:  { desktop: 300, mobile: 310 },
  };

  // === CİHAZ DURUMU ===
  let isMobile = window.innerWidth <= 768;
  window.addEventListener("resize", function () {
    isMobile = window.innerWidth <= 768;
    if (unitState?.mode) {
      speed = roadSpeeds[unitState.mode][isMobile ? "mobile" : "desktop"];
    }
  });

  // === MODs / STATE ===
  function getModes() {
    // return ["eco", "city", "sport", "sport+", "stock"]; ***stock issue and handle customize order
    return ["stock","eco", "city", "sport", "sport+"];
  }
  const modes = getModes();
  const unitState = {
    level: 0,           // -4 … 4
    // mode: modes[2],     // ***stock issue
    mode: modes[3],     // sport for now
  };
  // modeElements[2]?.classList.add("visible"); // ***stock issue
  modeElements[3]?.classList.add("visible");


  // ----------------------
  const levelButtons = document.querySelectorAll(".level-button");
  const mainButton = document.querySelector(".main-button");
  const mainButtonTouchArea = document.querySelector(".main-button-touch-area");
  const modeLights = document.querySelectorAll(".light");
  const levelLights = document.querySelectorAll(".level-light");
  const pcValve = document.querySelector(`svg[data-role='valve'][data-valve-type='pc']`);
  const pcPlate = pcValve?.querySelector('[data-name="plate"]');
  const pcShaft = pcValve?.querySelector(".svg-shaft");
  const stockValve = document.querySelector(`svg[data-role='valve'][data-valve-type='stock']`);
  const stockPlate = stockValve?.querySelector('[data-name="plate"]');
  const stockShaft = stockValve?.querySelector(".svg-shaft");


  const valveDurations = {
    stock: 2000,
    eco: 2500,
    city: 1500,
    sport: 1000,
    "sport+": 500,
  };

  const maxOpeningAngles = {
    stock: 65,
    eco: 55,
    city: 70,
    sport: 75,
    "sport+": 80,
  };

  if (stockPlate) stockPlate.style.transitionDuration = `${valveDurations.stock}ms`;

  function setValveTransitionDurations() {
    const currentMode = unitState.mode;
    const animationDuration = valveDurations[currentMode];
    if (pcPlate)  pcPlate.style.transitionDuration  = `${animationDuration}ms`;
    if (pcShaft)  pcShaft.style.transitionDuration  = `${animationDuration}ms`;
    if (stockPlate) stockPlate.style.transitionDuration = `${valveDurations.stock}ms`;
    if (stockShaft) stockShaft.style.transitionDuration = `${valveDurations.stock}ms`;
  }



  const gasPedal = document.querySelector(".gas-pedal");
  const shoeSvg = document.querySelector(".gas-pedal-shoe");
  const pressText = document.querySelector(".push-me-text");
  const valvesContainer = document.querySelector(".hp-what-is-pc__valves");

  function handleGasPedalPress() {
    const stockAngle = maxOpeningAngles.stock;
    const currentMode = unitState.mode;
    const pcAngle = maxOpeningAngles[currentMode] || stockAngle;

    setValveTransitionDurations();
    const stockTransitionProperty = `rotate3d(1, 0, 0, ${stockAngle}deg)`;
    const pcTransitionProperty = `rotate3d(1, 0, 0, ${pcAngle}deg)`;

    const calculatedPcBackgroundPosition = 200 - pcAngle;
    const calculatedStockBackgroundPosition = 200 - pcAngle;

    if (shoeSvg) shoeSvg.style.transform = `scale(0.925) translateY(10%)`;
    if (gasPedal) {
      gasPedal.style.transform = `translateY(4px)`;
      gasPedal.style.boxShadow = `0 0 0 #000`;
    }
    if (stockPlate) stockPlate.style.transform = stockTransitionProperty;
    if (pcPlate) pcPlate.style.transform = pcTransitionProperty;
    if (stockShaft) stockShaft.style.backgroundPositionY = `${calculatedStockBackgroundPosition}%`;
    if (pcShaft) pcShaft.style.backgroundPositionY = `${calculatedPcBackgroundPosition}%`;
    if (pressText) pressText.style.opacity = 0;
  }

  function handleGasPedalRelease() {
    const closingTransitionDuration = 200;
    if (stockPlate) stockPlate.style.transitionDuration = `${closingTransitionDuration}ms`;
    if (pcPlate) pcPlate.style.transitionDuration = `${closingTransitionDuration}ms`;
    if (stockShaft) stockShaft.style.transitionDuration = `${closingTransitionDuration}ms`;
    if (pcShaft) pcShaft.style.transitionDuration = `${closingTransitionDuration}ms`;

    if (gasPedal) gasPedal.style.transform = ``;
    if (shoeSvg) shoeSvg.style.transform = ``;
    if (gasPedal) gasPedal.style.boxShadow = ``;

    const transitionProperty = `rotate3d(1, 0, 0, 0deg)`;
    if (stockPlate) stockPlate.style.transform = transitionProperty;
    if (pcPlate) pcPlate.style.transform = transitionProperty;

    if (stockShaft) stockShaft.style.backgroundPositionY = `200%`;
    if (pcShaft) pcShaft.style.backgroundPositionY = `200%`;
    if (pressText) pressText.style.opacity = 1;
  }

  if (valvesContainer) {
    valvesContainer.addEventListener("mousedown", handleGasPedalPress);
    valvesContainer.addEventListener("touchstart", handleGasPedalPress);
  }
  document.addEventListener("mouseup", handleGasPedalRelease);
  document.addEventListener("touchend", handleGasPedalRelease);

  function handleLevelLights() {
    levelLights.forEach((light) => {
      light.classList.remove("green", "red");
    });
    if (unitState.level === 0) return;
    const isLevelPositive = unitState.level > 0;
    const targetLightIndex = isLevelPositive ? unitState.level - 1 : unitState.level + 4;
    const targetLight = levelLights[targetLightIndex];
    if (targetLight) targetLight.classList.add(isLevelPositive ? "green" : "red");
  }

  function handleModeLight() {
    const activeModeIndex = modes.indexOf(unitState.mode);
    if (unitState.mode === "stock") return;
    modeLights.forEach((light, index) => {
      // light.classList.toggle("visible", index === activeModeIndex  ); ***stock first
      light.classList.toggle("visible", index === activeModeIndex - 1 );
    });
  }


  function updateFlashingBorders() {
    const flashingBorders = document.querySelectorAll(".flashing-border.half-opacity");
    const isStock = unitState.mode === "stock";
    flashingBorders.forEach((el) => {
      el.style.setProperty("opacity", isStock ? "0" : "0.25", "important");
      el.style.pointerEvents = isStock ? "none" : "auto";
    });
  }

  levelButtons.forEach((button) => {
    button.addEventListener("click", function () {
      const target = button.classList.contains("minus-button") ? "minus" : "plus";
      const currentLevel = unitState.level;
      const nextLevel = target === "minus" ? Math.max(-4, currentLevel - 1) : Math.min(4, currentLevel + 1);
      unitState.level = nextLevel;
      handleLevelLights();
    });
  });

  // === MOD UPDATES ===
  function setMode(nextMode) {
    if (!modes.includes(nextMode)) return;
    const prevMode = unitState.mode;

    unitState.mode = nextMode;
    unitState.level = 0;

    speed = roadSpeeds[nextMode][isMobile ? "mobile" : "desktop"];

    if (nextMode === "stock") {
      modeLights.forEach((light) => light.classList.remove("visible"));
    } else {
      handleModeLight();
    }

    setValveTransitionDurations();
    handleModeContent(modes.indexOf(nextMode));
    handleLevelLights();
    updateFlashingBorders();


    renderValveInfo();

  }

  function handleModeContent(nextModeIndex) {
    if (modes.length === 0) return;
    const currentElement = modeElements.find((el) => el.classList.contains("visible"));
    if (currentElement) currentElement.classList.remove("visible");
    const nextModeElement = modeElements[nextModeIndex];
    if (nextModeElement) nextModeElement.classList.add("visible");
  }

  // === PC UNIT ===
  function handleMainButtonClick() {
    const activeMode = unitState.mode;
    const nextModeIndex = (modes.indexOf(activeMode) + 1) % modes.length;
    const nextMode = modes[nextModeIndex];
    setMode(nextMode);
  }
  if (mainButton) mainButton.addEventListener("click", handleMainButtonClick);
  if (mainButtonTouchArea) mainButtonTouchArea.addEventListener("click", handleMainButtonClick);

  // === INFO DD ===

  const MODE_LABELS = { eco: "Eco", city: "City", sport: "Sport", "sport+": "Sport+", stock: "Stock" };

  function buildValveInfo() {
    const container = document.getElementById("hp-what-is-pc__valve-info");
    if (!container) return;

    let text = container.dataset.text

    container.innerHTML = `
      <div class="mode-dd" data-role="mode-dd">
        <div class="mode-dd__inner">
          <p>${text}</p>
        </div>
        <ul id="mode-dd__list" class="mode-dd__list"></ul>
      </div>
    `;

    const listEl = container.querySelector(".mode-dd__list");
    getModes().forEach((m) => {
      const li = document.createElement("li");
      li.className = "mode-dd__item";
      li.dataset.mode = m;
      li.textContent = MODE_LABELS[m] || m;
      li.addEventListener("click", () => {
        setMode(m);
      });
      listEl.appendChild(li);
    });



  }



  function pcThrottleBodyShowModeInfo(){
    const visibleMode = document.querySelector('[data-role="mode"].visible');
    const targetInfo = document.getElementById("hp-what-is-pc__currentMode");

    if (visibleMode && targetInfo) {
        const modeText = visibleMode.querySelector(".hp-what-is-pc__mode-image-text");
        if (modeText) {
          targetInfo.innerHTML = modeText.innerHTML;
          const infoSpan = targetInfo.querySelector(".mode-icon-info");
          if (infoSpan) {
            infoSpan.textContent = infoSpan.textContent.replace(":", "");
          }
        }
    }
  }
    
  function getColors() {
    const listItems = document.querySelectorAll(".hp-what-is-pc__cta li.mode-content");
    const colors = [];
    listItems.forEach(li => {
      const styleAttr = li.querySelector(".hp-what-is-pc__mode-image-text")?.getAttribute("style") || "";
      const match = styleAttr.match(/--mode-color:\s*(#[0-9a-fA-F]+)/);
      if (match) {
        colors.push(match[1]);
      }
    });
    return colors; 
  }
  
  function renderValveInfo() {
    const container = document.getElementById("hp-what-is-pc__valve-info");
    if (!container) return;

    const labelEl = container.querySelector(".mode-dd__label");
    const listItems = container.querySelectorAll(".mode-dd__item");

    const currentMode = unitState.mode;

    if (labelEl) labelEl.textContent = MODE_LABELS[currentMode] || currentMode;

    listItems.forEach((li,i) => {
      li.classList.toggle("is-active", li.dataset.mode === currentMode);
        if (li.classList.contains("is-active")) {
          let colors = getColors();
          // li.style.color = colors[i];
          li.style.backgroundColor = colors[i];
          
        }else{
          // li.style.color = "#000";
          li.style.backgroundColor = "#fff";
        }
    });

    pcThrottleBodyShowModeInfo()
  }

  // === STARTER ===
  speed = roadSpeeds[unitState.mode][isMobile ? "mobile" : "desktop"]; 
  buildValveInfo();
  renderValveInfo();



















});